import axios from 'axios';
import PageInterface from '@/interfaces/PageInterface';
import { env } from '@/helpers';

class PageAPI {
  static get(params: Record<string, any>): Promise<PageInterface> {
    return new Promise((resolve, reject) => {
      axios.get<PageInterface>(`${window.ioappConfig.ajaxUrl}`, {
        params: {
          action: 'page',
          ...params,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        const pageResponse = e?.response?.data;

        if (pageResponse) {
          resolve(pageResponse);
        } else {
          reject(e);
        }
      });
    });
  }

  static getSystemPage(slug: string): Promise<PageInterface> {
    return new Promise((resolve, reject) => {
      axios.get<PageInterface>(`${env('API_BASE_PATH')}system-page`, {
        params: {
          slug,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((e) => {
        const pageResponse = e?.response?.data;

        if (pageResponse) {
          resolve(pageResponse);
        } else {
          reject(e);
        }
      });
    });
  }
}

export default PageAPI;
